import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import './CarouselTransition';

document.addEventListener('DOMContentLoaded', () => {
    const splides = document.querySelectorAll('.pgmutual-image-carousel');

    if (!!splides && splides.length > 0) {
        splides.forEach((splide) => {
            const theSplide = new Splide(splide, {
                type: 'loop',
                autoplay: true,
                gap: 0,
                perPage: 3,
                perMove: 1,
                pagination: false,
                focus: 'center',
                pauseOnHover: false,
                interval: parseInt(splide.dataset.interval) * 1000 || 300,
                breakpoints: {
                    890: { perPage: 1 }
                },
            });

            // theSplide.on("move", function (newIndex, prevIndex, destIndex) {
            //     console.log(newIndex);
            //     console.log(prevIndex);
            //     console.log(destIndex);
            // });

            theSplide.mount();
        });
    }
});
